import React, { useEffect, useRef, useState } from 'react';
import { useAudio } from '../../contexts/AudioContext';
import { getScreenshotSignedUrl } from '../../services/HalogenService';
import { IoSquareSharp } from 'react-icons/io5';
import './PlaybackBar.css';
import { PlayPauseButton } from '../../elements/PlayPauseButton/PlayPauseButton';
import { PlayNextButton } from '../../elements/PlayNextButton/PlayNextButton';
import { PlaybackRateButton } from '../../elements/PlaybackRateButton/PlaybackRateButton';
import { ProgressBar } from '../../elements/ProgressBar/ProgressBar';
import { GoToQueueButton } from '../../elements/GoToQueueButton/GoToQueueButton';
import { useNavigate } from 'react-router-dom';
import { GoToFeedButton } from '../../elements/GoToFeedButton/GoToFeedButton';
import { PLAYBACK_BAR_HEIGHT, MOBILE_PLAYBACK_BAR_HEIGHT } from '../../constants';

export function PlaybackBar({ height }) {
    const { currentlyPlayingClip } = useAudio();
    const navigate = useNavigate();
    const [screenshotUrl, setScreenshotUrl] = useState(null);
    const marqueeRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (currentlyPlayingClip) {
            const contentWidth = marqueeRef.current.scrollWidth;
            const containerWidth = marqueeRef.current.offsetWidth;
            setIsOverflowing(contentWidth > containerWidth);
        }
    }, [currentlyPlayingClip]);

    // Fetch the screenshot URL for the currently playing clip
    useEffect(() => {
        if (currentlyPlayingClip) {
            getScreenshotSignedUrl(currentlyPlayingClip.id, 'xsmall')
                .then(url => setScreenshotUrl(url.signedUrl))
                .catch(err => console.error(err));
        }
    }, [currentlyPlayingClip]);

    const handleClipInfoClick = () => {
        if (currentlyPlayingClip) {
            navigate(`/focus/${currentlyPlayingClip.id}`);
        }
    };

    return (
        <div className="playbackBar" style={{ height: height }}>
            <div className="playbackBarRowView">
                <div className="playbackClipInfo" onClick={handleClipInfoClick} style={{ maxHeight: windowWidth > 786 ? PLAYBACK_BAR_HEIGHT : MOBILE_PLAYBACK_BAR_HEIGHT }} role="button">
                    {windowWidth > 786 && (screenshotUrl ?
                        <img src={screenshotUrl} className="screenshot" alt="Clip Screenshot" style={{ height: `${windowWidth > 786 ? PLAYBACK_BAR_HEIGHT - 5 : MOBILE_PLAYBACK_BAR_HEIGHT - 5}px` }} />
                        : <IoSquareSharp size={'200'} className="screenshot" color={'#0D0730'} />
                    )}
                    <div className="playbackClipInfoText">
                        <div
                            ref={marqueeRef}
                            className={`marquee ${isOverflowing ? 'animate' : ''}`}
                        >                        <h3 className="playbackClipTitle">{currentlyPlayingClip ? currentlyPlayingClip.title : "Not Playing"}</h3>
                        </div>
                        {windowWidth > 786 && <p className="playbackClipDescription">{currentlyPlayingClip ? currentlyPlayingClip.description : "Not Playing"}</p>}
                    </div>
                </div>
                <div className="playbackControls">
                    <div className="playbackButtons">
                        <PlaybackRateButton size={windowWidth > 786 ? 30 : 25} color={'#F2EFF4'} background_color={'#0D0730'} />
                        <div className="middlePlaybackButton">
                            <PlayPauseButton size={windowWidth > 786 ? 50 : 30} color={'#F2EFF4'} isPlaybackBarButton={true} />
                        </div>
                        <PlayNextButton className="playbackButton" size={windowWidth > 786 ? 35 : 25} color={'#F2EFF4'} />
                    </div>
                    {windowWidth > 786 && <ProgressBar className='progressBar' width='90%' />}
                </div>
                <div className="navControls">
                    <>
                        {window.location.pathname !== '/queue' ?
                            (<GoToQueueButton className="navButton" size={windowWidth > 786 ? 50 : 20} color={'#F2EFF4'} />)
                            :
                            (<GoToFeedButton className="navButton" size={windowWidth > 786 ? 50 : 20} color={'#F2EFF4'} />)
                        }
                    </>
                </div>
            </div>
            {windowWidth < 786 && <div className='progressBar'>
                <ProgressBar width='60%' trackBarHeight='2px' thumbHeight='8px' thumbWidth='8px' fontSize='10px' />
            </div>}
        </div>
    );
}
